module.exports = __webpack_public_path__ + "media/fonts/fa-regular-400-4b601f86ce9a86da887a2dbf51eb457b.woff2";